import React, { ChangeEvent, useEffect, useState } from 'react'

import Typography from '@mui/material/Typography'
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
} from '@mui/material'
import { TabContext, TabList } from '@mui/lab'
import AutoCompleteMultiSelect from '../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.js'
import TextAreaComponents from '../../components/TextAreaComponents/TextAreaComponents.tsx'
import galleryIcon from './../../../assets/icons/gallery.png'
import plusIcon from './../../../assets/icons/plus.png'
import './AddItem.css'
import { Delete } from '@mui/icons-material'
import CancelIcon from '@mui/icons-material/Cancel'
import StickyHeadTable from '../../components/SpecificationTable/Specification.tsx'
import Details from './../../product/components/Details.tsx'
import Story from './../../product/components/Story.tsx'
import Instructions from './../../product/components/Instructions.tsx'
import Cancel from './../../../assets/icons/close.png'
import DetailsTable from '../../components/SpecificationTable/DetailsTable.tsx'
import SectionTable from './SectionTable.tsx'
import ChickenIcon from './../../../assets/icons/turkey.png'
import ChickenLegIcon from './../../../assets/icons/chicken-leg.png'
import Burger1Icon from './../../../assets/icons/burger1.png'
import Burger2Icon from './../../../assets/icons/burger.png'
import FullPizzaIcon from './../../../assets/icons/pizza.png'
import pizzaIcon from './../../../assets/icons/pizza (1).png'
import { getMinimalContentHeight } from '@mui/x-data-grid/hooks/features/rows/gridRowsUtils.js'
import axios from 'axios'
import { uploadOneFiles } from '../../../fileUploader/SingleFileUploader.js'
import { toast } from 'react-toastify'
import LoadingView from '../../components/LoadingView/LoadingView.js'
import SweetAlertModal from '../../components/SweetAlertModal/SweetAlertModal.js'



function KeywordTagDialog(props) {
  console.log(props.editKeywordData)
  const imageUrl=props.editKeywordData?props.editKeywordData.imgurl:''
  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem('restaurant'));
  const [openConfirmaitonModal, setopenConfirmaitonModal]=useState(false)
  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  }

 
  const [keyword, setKeyword] = useState(props.editKeywordData?props.editKeywordData.name:null)
  
 

  const handleKeyword = (event) => {
    setKeyword(event.target.value)
  }

 
 

  const handleClose = () => {
    // setState({
    //   ...state,
    //   selectedImages: [], 
    // });
    props.onHandleKeywordDialog(false)

  }

//   const [state, setState] = useState<ImageUploadState>({
//     selectedImages: [],
// })
const [state, setState] = useState<ImageUploadState>({
  selectedImages:props.editKeywordData?.imgurl || [], 
});

useEffect(() => {
  setState({
    ...state,
    selectedImages: props.editKeywordData?.imgurl || [],
  });
  setKeyword(props.editKeywordData?.name)
  setlogoImg(props.editKeywordData?.imgurl)
 
}, [props.editKeywordData]);
console.log(state.selectedImages)

const [logoImg, setlogoImg] = useState([])


  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (files) {
        const imagesArray: string[] = []
        const remainingSlots = 5 - state.selectedImages.length
        const filesToUpload = Array.from(files).slice(0, remainingSlots)
        setlogoImg(filesToUpload);
        for (let i = 0; i < filesToUpload.length; i++) {
            const file = filesToUpload[i]
            const reader = new FileReader()
            reader.onloadend = () => {
                imagesArray.push(reader.result as string)
                if (imagesArray.length === filesToUpload.length) {
                    const updatedImages = [...state.selectedImages, ...imagesArray]
                    setState({ selectedImages: updatedImages })
                }
            }
            reader.readAsDataURL(file)
        }
    }
}
const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages]
    updatedImages.splice(index, 1)
    setState({ selectedImages: updatedImages })
}

const fileUpload=async(data)=>{
    console.log(data)
  var res= await uploadOneFiles(data[0]);
 return res
}
const onClickSave =async () => {
 var logoUrl= await fileUpload(logoImg)
    var valid=true
    if(!!keyword==false){
      valid=false
    }
   var obj={
    id: "string",
    KeywordTagName: keyword,
    // RestaurantId: Restauranttoken.id,
    KeywordTagImage:logoUrl[0],
    isActive: true,
    CreatorId: "string",
    CreationDate: "2023-08-21T06:38:08.240Z",
    ModifierId: "string",
    ModificationDate: "2023-08-21T06:38:08.240Z"
  }
  var  url = apiAddress + "/api/Keyword/InsertKeywordTag"
  if(valid){
    axios
    .post(url, obj)
    .then((response) => {
      toast.success("successfully submitted", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
      props.reloadData()
      setKeyword(null)
    });
  }
 
  props.onHandleKeywordDialog(false)
  setopenConfirmaitonModal(false)
  }

  const onClickUpdate=async()=>{
    SetloadingModal(true);
    console.log(logoImg)
  var logoImageUrl=''
    if (typeof logoImg[0] == 'string') {
      logoImageUrl = logoImg[0]   
  }
  else{
    console.log('called')
    var res=await fileUpload(logoImg)
    logoImageUrl=res[0]
  }
    var valid=true
  if(!!keyword==false)
  {
    valid=false
  }
    var obj={
      id: props.editKeywordData.id,
      KeywordTagName: keyword,
      KeywordTagImage: logoImageUrl,
      isActive: true,
      creatorId: "string",
      creationDate: "2023-08-21T06:38:08.240Z",
      modifierId: "string",
      modificationDate: "2023-08-21T06:38:08.240Z"
    }
  console.log(obj)
    var  url = apiAddress + "/api/Keyword/UpdateKeywordTag"
  
    if(valid){
      
      axios
      .put(url, obj)
      .then((response) => {
        SetloadingModal(false);
        toast.success("successfully submitted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
      });
        console.log(response.data);
        props.onHandleKeywordDialog(false)
      });
    }
  }
  console.log(keyword)
  return (
    <div>
      <React.Fragment>
        <Dialog
         fullWidth={true}
          maxWidth='sm'
          open={props.open}
          onClose={handleClose}
        >
            <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to save this?"} open={openConfirmaitonModal} onyes={onClickSave} close={() => { setopenConfirmaitonModal(false) }} />
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Add KeywordTag</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
            <div>
              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: '2rem' }}>
                    Keyword
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  
                  <TextField
                    label="Name"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: '#371B17' } }}
                    // defaultValue={props.editKeywordData?props.editKeywordData.name:''}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>
                                        Logo
                                    </Typography>
                                </Grid>
                                <Grid xs={9}>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        //   color="primary"
                                        className='uploadButton'
                                    // style={{ backgroundColor: 'white', color: 'gray' }}
                                    >
                                        <img
                                            src={galleryIcon}
                                            alt="photo"
                                        // style={{ width: '2rem' }}
                                        />
                                        Upload
                                        <input
                                            hidden
                                            accept="image/*"
                                            multiple
                                            type="file"
                                            onChange={handleImageUpload}
                                            disabled={state.selectedImages.length >= 1}
                                        />
                                    </Button>
                                </Grid>

                                {/* image show start */}
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={9}>
                                        <Grid container spacing={2}>
                                            {state.selectedImages?state.selectedImages.map((image, index) => (
                                                <Grid item xs={2} sm={2} md={2} key={index}>
                                                    {/* <Paper> */}
                                                    <div
                                                        style={{
                                                            position: 'relative',
                                                            paddingTop: '20px',
                                                        }}
                                                    >
                                                        <img
                                                            src={image}
                                                            alt={`Preview ${index + 1}`}
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '100%',
                                                                objectFit: 'cover',
                                                            }}
                                                        />
                                                        <IconButton
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-6px',
                                                                right: '-23px',
                                                                color: 'gray',
                                                            }}
                                                            onClick={() => handleDeleteImage(index)}
                                                        >
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </div>
                                                    {/* </Paper> */}
                                                </Grid>
                                            )):''}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* image show end */}
                            </Grid>

              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                  {props.editKeywordData?(
                  <Button className="AddItemButtons" onClick={onClickUpdate}>
                    Update
                  </Button>
                  ):(
                    <Button className="AddItemButtons" onClick={()=>setopenConfirmaitonModal(true)}>
                    Save
                  </Button>
                  )
                  }
                </Grid>
              </Grid>

              
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  )
}

export default KeywordTagDialog
